import { environment } from '../../../environment/environment';
import { CryptoService } from '../../../service/crypto.service';
import { RaygunErrorHandlerService } from '../../../service/raygun.service';

const { logError } = RaygunErrorHandlerService();

export const getStoredTokenAsync = async (): Promise<string | undefined> => {
  const encryptedAuth = localStorage.getItem(environment.authKey);

  try {
    if (encryptedAuth) {
      const decryptedAuth = await CryptoService.decrypt(encryptedAuth, environment.cryptoKey);
      const auth = JSON.parse(decryptedAuth);

      if (typeof auth === 'string') {
        return auth;
      }
    }
  } catch (error) {
    removeStoredToken();
    logError(error, ['login.helper', 'getStoredTokenAsync']);
  }
  return undefined;
};

export const storeTokenAsync = async (token: string) => {
  try {
    const encryptedAuth = await CryptoService.encrypt(JSON.stringify(token), environment.cryptoKey);
    localStorage.setItem(environment.authKey, encryptedAuth);
  } catch (error) {
    logError(error, ['login.helper', 'storeTokenAsync']);
  }
};

export const removeStoredToken = () => {
  localStorage.removeItem(environment.authKey);
};

export const getRememberedEmail = async () => {
  const encryptedEmail = localStorage.getItem('rememberedEmail');
  try {
    if (encryptedEmail) {
      const decryptedEmail = await CryptoService.decrypt(encryptedEmail, environment.cryptoKey);
      return decryptedEmail;
    }
  } catch (e) {
    logError(e, ['login.helper', 'getRememberedEmail']);
  }
  return '';
};

export const saveRememberedEmail = async (email: string) => {
  try {
    const encryptedEmail = await CryptoService.encrypt(email, environment.cryptoKey);
    localStorage.setItem('rememberedEmail', encryptedEmail);
  } catch (error) {
    logError(error, ['login.helper', 'saveRememberedEmail']);
  }
};

export const removeRememberedEmail = () => {
  localStorage.removeItem('rememberedEmail');
};
